module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBundle === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBundle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBundle) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBundle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBundle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-usb fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.actualBundle.sub_bundle[_vm.bundleIndex].bundle_name))])]), _vm._v(" "), (_vm.flagDisplayBundle) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h1', {
    staticClass: "page-heading"
  }, [_vm._v(_vm._s(_vm.actualBundle.sub_bundle[_vm.bundleIndex].bundle_id))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content block-content-narrow"
  }, [_c('h1', {
    staticClass: "page-heading"
  }, [_vm._v(_vm._s(_vm.actualBundle.sub_bundle[_vm.bundleIndex].bundle_id))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveMyProfile()
      }
    }
  }, [_vm._v("New Button")])])])])])])]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54fb46b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/measurements/bundle.vue
// module id = 1543
// module chunks = 4